import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { Body1 } from "@fluentui/react-components";
/**
 * Expects a numerical value and converts it toFixed(if precision is supplied) or toLocaleString
 * Can pass optional units to be appending to the end of the string
 * @param props
 * @returns
 */
export const StringifiedPropertyLine = (props) => {
    StringifiedPropertyLine.displayName = "StringifiedPropertyLine";
    const value = props.precision !== undefined ? props.value?.toFixed(props.precision) : props.value?.toLocaleString();
    const withUnits = props.units ? `${value} ${props.units}` : value;
    return (_jsx(PropertyLine, { ...props, children: _jsx(Body1, { title: props.title, children: withUnits ?? "" }) }));
};
//# sourceMappingURL=stringifiedPropertyLine.js.map